import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import ApiService from "../util/ApiService";
import CustomPagination from "../util/CustomPagination";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Swal from "sweetalert2"; // Importando o JS do Bootstrap

require("./assets/css/Specialties.css");

const SpecialtiesEditModal = ({ show, onHide, specialty, actionText = "Salvar" }) => {
    const [specialtyData, setSpecialtyData] = useState({
        id : "",
        name: "",
        description: "",
        status: 1
    });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (specialty?.id) {
            setSpecialtyData(specialty);
        } else {
            setSpecialtyData({
                name: "",
                description: "",
                status: 1
            });
        }
    }, [specialty]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSpecialtyData({ ...specialtyData, [name]: value });
    };

    const handleSave = async () => {
        setLoading(true);
        try {
            let response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}specialties/register`,
                specialtyData,
                true
            );

            if (response?.code === 200) {
                Swal.fire("Sucesso", "Especialidade salva com sucesso!", "success").then(() => {
                    onHide(true);
                });
            }
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false); // Finaliza o carregamento
        }
    };


    return (
        <Modal show={show} onHide={onHide} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>{specialty?.id ? "Editar Especialidade" : "Cadastrar Especialidade"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className=" p-3">
                    <div className="mb-3">
                        <label className="form-label">Nome</label>
                        <input
                            type="text"
                            className="form-control"
                            name="name"
                            value={specialtyData?.name}
                            onChange={handleInputChange}
                            placeholder="Digite o nome da especialidade"
                        />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Descrição</label>
                        <textarea
                            className="form-control"
                            name="description"
                            value={specialtyData?.description}
                            onChange={handleInputChange}
                            placeholder="Digite uma descrição"
                        />
                    </div>
                </div>

                <div className="d-flex justify-content-end mt-3">
                    <button className="btn btn-dark ms-2"  type="button" onClick={() =>onHide()} disabled={loading}>
                        <i className="fa fa-close"></i> Cancelar
                    </button>
                    <button className="btn btn-info ms-2" type="button"  onClick={() =>handleSave()} disabled={loading}>
                        {loading ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status"
                                      aria-hidden="true"></span>
                                Salvando...
                            </>
                        ) : (
                            <>
                                <i className="fa fa-plus me-2"></i> {actionText}
                            </>
                        )}
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default SpecialtiesEditModal;
